import { InputCmp } from '@/components/atom/textbox/input'
import { SetStateAction, useEffect, useRef, useState } from 'react'
import { createComment, fetchViewComments } from '@/services/apis/api'
import { useAppSelector } from '@/hooks/storeHooks/storehooks'
import { Skeleton } from '@/components/ui/skeleton'
import { convertToUserTimezone } from '@/lib/utils'
import { toast } from 'sonner'
import { TextareaCmp } from '@/components/atom/textarea/textArea'
import { AxiosResponse } from 'axios'
import { useAuth0 } from '@auth0/auth0-react'

interface CreatedBy {
  Name: string
}

export interface CommentProps {
  label: string
  attributes: Attributes
  Id: string
  IsDeleted: boolean
  CaseId: string
  CreatedBy: CreatedBy
  Name: string
  CreatedDate: string
  Field: string
  DataType: string
  OldValue: string
  NewValue: string
  CommentBody: string
  color?: string
}

type CreateCommentResponse = AxiosResponse<{ data: CommentProps }>
export interface CommentCardProps {
  comment: CommentProps
  color: boolean
  CommentsList: CommentProps[]
}

export type FetchViewComments = AxiosResponse<{ data: CommentProps[] }>

export interface Attributes {
  type: string
  url: string
}

const CommentsSection = () => {
  const commentsEndRef = useRef<HTMLDivElement | null>(null)

  const [comments, setComments] = useState<CommentProps[]>([])
  const [commentInp, setCommentInp] = useState('')
  const [loading, setLoading] = useState(true)
  const [creationLoading, setCreationLoading] = useState(false)
  const { user } = useAuth0()

  const caseDetails = useAppSelector(state => state.caseManagement.caseDetails)

  console.log(caseDetails, 'caseDetails')
  const fetchComments = async (id: string) => {
    setLoading(true)
    if (loading && !id) {
      toast.error('id is undefined')
      return
    }

    const res = (await fetchViewComments(id)) as FetchViewComments
    setLoading(false)
    if (res.status === 200) {
      res?.data.data?.map(node => {
        const filteredComments = res?.data?.data.filter(
          node => node.attributes.type === 'CaseComment',
        )
        if (node.attributes.type === 'CaseComment') {
          const currentElement = filteredComments?.findIndex(
            element => node?.Id === element?.Id,
          )

          if (currentElement === 0) {
            // First element
          } else {
            const previousComment = filteredComments[currentElement - 1]
            const currentComment = filteredComments[currentElement]
            if (
              previousComment?.CreatedBy?.Name ===
              currentComment?.CreatedBy?.Name
            ) {
              // Same user
            } else {
              if (previousComment?.color === 'red') {
                // Different user
              } else if (previousComment?.color === 'white') {
                // Different user
              }
            }
          }
        } else {
          return node
        }
      })
      setComments(res.data.data)
    } else {
      console.error('Error fetching comments:', res)
      toast.error("Can't load data")
    }
  }

  useEffect(() => {
    if (Object.keys(caseDetails).length > 0) {
      fetchComments(caseDetails?.Id as unknown as string)
    }
  }, [caseDetails])

  useEffect(() => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollTop = commentsEndRef.current.scrollHeight
    }
  }, [comments.length])

  const handleSend = async () => {
    setCreationLoading(true)
    const res = (await createComment({
      caseId: caseDetails?.Id,
      commentBody: user?.name + ': ' + commentInp,
    })) as CreateCommentResponse
    if (res.status === 200) {
      setCommentInp('')
      fetchComments(caseDetails?.Id)
    } else {
      console.error('Error creating comment:', res)
      toast.error('Error creating comment')
    }
    setCreationLoading(false)
  }

  const [searchQuery, setSearchQuery] = useState('')

  const handleSearch = (e: SetStateAction<string>) => {
    setSearchQuery(e)
  }

  const filteredComments: CommentProps[] = comments.filter(
    comment =>
      comment.CommentBody?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      comment.CreatedBy?.Name?.toLowerCase().includes(
        searchQuery.toLowerCase(),
      ),
  )

  const commentList = comments?.filter(comment => {
    return comment.attributes.type === 'CaseComment'
  })
  let prevName = ''
  let colo = true

  const perm = useAppSelector(state => state.menu.perms)

  return (
    <div className=' flex flex-col  justify-between w-full h-full'>
      <h1 className=' font-semibold text-kpi-supporting-1 text-primary-foreground mb-2'>
        Comments
      </h1>

      <InputCmp
        node={{
          id: '1a',
          formControl: 'textbox',
          fieldName: 'search_comments',
          value: searchQuery,
          placeholder: 'Search',
          layout: {
            lg: 'lg:w-full',
            md: 'md:w-full',
            sm: 'sm:w-full',
          },
          childClass: 'rounded-radius-sm',
        }}
        handleChange={(_eve, val) => handleSearch(val)}
      />

      <div
        className=' overflow-y-auto spec-scroll max-h-full '
        ref={commentsEndRef}
      >
        {filteredComments.map(comment => {
          if (comment.attributes.type === 'CaseComment') {
            if (comment.CreatedBy.Name !== prevName) {
              colo = !colo
            }
            prevName = comment.CreatedBy.Name
            return (
              <CommentCard
                key={comment?.Id}
                comment={comment}
                CommentsList={commentList}
                color={colo}
              />
            )
          } else if (comment.attributes.type === 'CaseHistory') {
            return (
              <div key={comment?.Id} className='flex justify-center mt-2'>
                {(comment.OldValue || comment.NewValue) && (
                  <div className='rounded-radius-full bg-info-dim-light inline-block px-4 py-2 text-kpi-supporting-1'>
                    <strong className='text-primary-foreground'>
                      {comment.label}
                    </strong>{' '}
                    {comment.OldValue && comment.NewValue ? (
                      <>
                        <span className='text-primary-foreground'>
                          Changed from
                        </span>{' '}
                        <span className='text-primary-foreground font-bold'>
                          {comment.OldValue}
                        </span>{' '}
                        <span className='text-primary-foreground'>to</span>{' '}
                        <span className='text-primary-foreground font-bold'>
                          {comment.NewValue}
                        </span>{' '}
                      </>
                    ) : comment.NewValue ? (
                      <>
                        <span className='text-primary-foreground'>Set to</span>{' '}
                        <span className='text-primary-foreground font-bold'>
                          {comment.NewValue}
                        </span>{' '}
                      </>
                    ) : null}
                    <span className='text-primary-foreground'>by</span>{' '}
                    <span className='text-primary-foreground'>
                      {comment.CreatedBy.Name}
                    </span>
                  </div>
                )}
              </div>
            )
          }
        })}
        {loading &&
          Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className='flex flex-row p-padding-xxs  w-full  gap-1 h-20 '
            >
              <Skeleton className='w-10 h-10 bg-[#d9dadb] rounded-radius-full' />
              <div className='flex-grow '>
                <Skeleton className='h-4 w-2/4 bg-[#d9dadb] rounded-radius-xs mb-2' />
                <Skeleton className='h-4 w-3/4 bg-[#d9dadb] rounded-radius-xs' />
              </div>
            </div>
          ))}
      </div>

      {perm['support.casemanagement'].includes('cases.create_comment') &&
        caseDetails.canAddComments && (
          <div className='sticky bottom-0 bg-primary flex justify-between min-h-[30px] max-h-[120px]'>
            <TextareaCmp
              node={{
                id: '1a',
                formControl: 'textarea',
                fieldName: 'type_comments',
                value: commentInp,
                rows: 1,
                placeholder: 'Comment here...',
                layout: {
                  lg: 'lg:w-full',
                  md: 'md:w-full',
                  sm: 'sm:w-full',
                },
                childClass:
                  'min-h-[30px] max-h-[120px] sticky absolute bottom-0 w-11/12 bg-primary text-primary-foreground z-10 resize-none flex justify-center py-6 px-3 bg-primary',
              }}
              handleChange={(_eve, val) => setCommentInp(val)}
            />
            <div className='flex items-center py-10 space-x-2 ml-2'>
              <button
                onClick={handleSend}
                disabled={commentInp.length === 0}
                className={`px-4 py-2 font-bold text-white rounded-radius-sm mb-3  bg-accent hover:bg-accent-hover `}
              >
                {creationLoading ? 'Sending...' : 'Send'}
              </button>
            </div>
          </div>
        )}
    </div>
  )
}

export default CommentsSection

const CommentCard: React.FC<CommentCardProps> = ({ comment, color }) => {
  return (
    <div id={comment?.Id} className={`flex justify-center mt-2 flex-col  `}>
      <div className='flex justify-center items-center'>
        <div className='flex-grow border-t border-secondary-border mx-2'></div>{' '}
        <span className='bg-secondary text-primary-foreground w-[90px] h-[22px] flex justify-center rounded-radius-full text-[0.8125rem] items-center'>
          {comment?.CreatedDate.substring(0, 10)}
        </span>
        <div className='flex-grow border-t border-secondary-border mx-2'></div>{' '}
      </div>
      <div
        className={`flex flex-row py-2 mt-1 px-2 justify-between w-full ${color ? 'bg-primary' : 'bg-table-raw'} `}
      >
        <div className='w-full'>
          <div className='flex items-center  '>
            <div
              className={`text-accent-foreground rounded-radius-full w-9 h-9 border-2 border-secondary flex items-center justify-center font-normal text-[16px] mr-2 shrink-0 ${color ? 'bg-accent' : 'bg-[#DF0E02]'}`}
            >
              {comment?.CreatedBy.Name.substring(0, 1)}
            </div>
            <div className='flex flex-row align-bottom gap-[6px]'>
              <span className='font-semibold text-primary-foreground'>
                {comment?.CreatedBy.Name}
              </span>
              <span className='text-kpi-supporting-1 text-secondary-foreground mt-1'>
                {convertToUserTimezone(comment.CreatedDate)
                  .split('at')[1]
                  ?.trim()
                  .replace(/\s[A-Z]+$/, '')}
              </span>
            </div>
          </div>
          <p className='mb-2 ml-11 text-primary-foreground break-words'>
            {comment?.CommentBody}
          </p>
        </div>
      </div>
    </div>
  )
}
